import { appendHelpText, createFieldScaffold, createLabelText } from "../shared.ts";
import type { RenderContext, RenderField } from "../types.ts";

export const renderCheckboxField = (
  field: RenderField<"CHECKBOX">,
  context: RenderContext,
): HTMLElement => {
  const scaffold = createFieldScaffold(field, context);

  const label = document.createElement("label");
  label.className = "fb-checkbox";

  const input = document.createElement("input");
  input.id = scaffold.inputId;
  input.name = field.key;
  input.required = field.required;
  input.type = "checkbox";
  input.value = "true";

  if (scaffold.helpId) {
    input.setAttribute("aria-describedby", scaffold.helpId);
  }

  label.append(input, createLabelText(field.label, field.required));
  scaffold.wrapper.append(label);
  appendHelpText(scaffold, field);

  return scaffold.wrapper;
};
